import Mustache from 'mustache'
import MESSAGES from 'core/data-model/constants/bi-messages'
import { formatNumber } from 'core/service/lib/number-format'

export const taxDeductionBenefit = ({ taxDeduction }) => ({
  stack: [
    { text: MESSAGES.TAX_DEDUCTION_BENEFIT_TITLE, style: 'title' },
    { text: MESSAGES.TAX_DEDUCTION_BENEFIT_SUB_TITLE, bold: true },
    {
      text: `${MESSAGES.TAX_DEDUCTION_BENEFIT_SUB_DESCRIPTION} ${MESSAGES.TAX_DEDUCTION_BENEFIT_SUB_DESCRIPTION_STRONG}`,
    },
    {
      fontSize: 12,
      table: {
        widths: [300, '*'],
        body: [
          [
            MESSAGES.TAX_DEDUCTION_BENEFIT_SUB_LIST[0].description,
            {
              text: Mustache.render(MESSAGES.TAX_DEDUCTION_BENEFIT_SUB_LIST[0].benefit, {
                value:
                  taxDeduction.taxDeductionTotalForYear === 0
                    ? '-'
                    : formatNumber(taxDeduction.taxDeductionTotalForYear, 2, true),
              }),
              alignment: 'right',
            },
          ],
        ],
      },
      layout: 'noBorders',
      margin: [20, 0, 30, 0],
    },
    {
      stack: [
        MESSAGES.TAX_DEDUCTION_BENEFIT_SUB_ADDITIONAL,
        { text: `${MESSAGES.NOTE}: ` },
        {
          text: `${MESSAGES.TAX_DEDUCTION_BENEFIT_SUB_NOTES[0][0]}${MESSAGES.TAX_DEDUCTION_BENEFIT_SUB_NOTES[0][1]}`,
          margin: [36, -13, 0, 0],
        },
        ' ',
        { text: `${MESSAGES.TAX_DEDUCTION_BENEFIT_SUB_NOTES[1][0]}` },
        ' ',
      ],
      style: 'disclaimer',
    },
  ],
  style: 'groupRow',
})

export const taxDeductionBenefitSukhapabdekdee = ({ taxDeduction }) => ({
  stack: [
    { text: MESSAGES.TAX_DEDUCTION_BENEFIT_TITLE, style: 'title' },
    { text: MESSAGES.TAX_DEDUCTION_BENEFIT_SUB_TITLE, bold: true },
    {
      text: `${MESSAGES.TAX_DEDUCTION_BENEFIT_SUB_DESCRIPTION} ${MESSAGES.TAX_DEDUCTION_BENEFIT_SUB_DESCRIPTION_STRONG}`,
    },
    {
      fontSize: 12,
      table: {
        widths: [300, '*'],
        body: [
          [
            MESSAGES.SUKHAPABDEKDEE_TAX_DEDUCTION_BENEFIT_SUB_LIST[0].description,
            {
              text: Mustache.render(MESSAGES.SUKHAPABDEKDEE_TAX_DEDUCTION_BENEFIT_SUB_LIST[0].benefit, {
                value:
                  taxDeduction.taxDeductionTotalForYear === 0
                    ? '-'
                    : formatNumber(taxDeduction.taxDeductionBasicPremiumForYear, 2, true),
              }),
              alignment: 'right',
            },
          ],
          [
            MESSAGES.SUKHAPABDEKDEE_TAX_DEDUCTION_BENEFIT_SUB_LIST[1].description,
            {
              text: Mustache.render(MESSAGES.SUKHAPABDEKDEE_TAX_DEDUCTION_BENEFIT_SUB_LIST[1].benefit, {
                value:
                  taxDeduction.taxDeductionRiderPremuimForYear === 0
                    ? '-'
                    : formatNumber(taxDeduction.taxDeductionRiderPremuimForYear, 2, true),
              }),
              alignment: 'right',
            },
          ],
        ],
      },
      layout: 'noBorders',
      margin: [20, 0, 30, 0],
    },
    {
      stack: [
        MESSAGES.TAX_CONSENT_DEDUCTION_BENEFIT_SUB_ADDITIONAL_PDF,
        ' ',
        { text: `${MESSAGES.NOTE}: ` },
        {
          text: `${MESSAGES.SUKHAPABDEKDEE_TAX_DEDUCTION_BENEFIT_SUB_NOTES_PDF[0][0]} ${MESSAGES.SUKHAPABDEKDEE_TAX_DEDUCTION_BENEFIT_SUB_NOTES_PDF[0][1]}`,
          margin: [36, -13, 0, 0],
        },
        ' ',
        {
          text: `${MESSAGES.SUKHAPABDEKDEE_TAX_DEDUCTION_BENEFIT_SUB_NOTES_PDF[1][0]} ${MESSAGES.SUKHAPABDEKDEE_TAX_DEDUCTION_BENEFIT_SUB_NOTES_PDF[1][1]}`,
          margin: [36, 0, 0, 0],
        },
      ],
      style: 'disclaimer',
    },
  ],
  style: 'groupRow',
})
